import { useMemo } from 'react';

import { theme } from '~/theme';

export const useSxStyles = () => {
  return useMemo(() => {
    return {
      viewRoot: {
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gridTemplateRows: '1fr',
        gridTemplateAreas: `
            "unitContent unitSelectorSlot"
          `,
      },
      demoChip: {
        margin: theme.spacing(0, 1),
      },
      unitSelectorSlot: {
        gridArea: 'unitSelectorSlot',
        position: 'relative',
      },
      unitSelectorDrawer: {
        position: 'absolute',
        right: 0,
        height: '100%',
        zIndex: 200,
      },
      unitSelector: {
        backgroundColor: '#fff',
        borderRight: `solid 1px ${theme.palette.divider}`,
        boxShadow: 3,
        minWidth: '350px',
        height: '100%',

        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto 1fr',
        gridTemplateAreas: `
            "unitSelectorTop"
            "unitSelectorContent"
          `,
      },
      unitSelectorTop: {
        gridArea: 'unitSelectorTop',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        // justifyContent: 'space-between',
        borderBottom: `solid 1px ${theme.palette.divider}`,
      },
      unitSelectorContent: {
        gridArea: 'unitSelectorContent',
        overflow: 'auto',
      },
      unitContent: {
        gridArea: 'unitContent',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto 1fr',
        gridTemplateAreas: `
            "workflowHeader"
            "workflowTable"
          `,
        overflow: 'auto',
      },
      header: {
        gridArea: 'workflowHeader',
        display: 'flex',
        padding: theme.spacing(1, 2),
        justifyContent: 'space-between',
      },
      content: { gridArea: 'workflowTable' },
      loading: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      },
    };
  }, []);
};
